import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({ name: 'chapterImage' })
export class ChapterImagePipe implements PipeTransform {
  transform(reportId: string): string {
    const PATH = '/assets/images/';

    switch (reportId) {
      case environment.products.dietAndNutrition:
        return PATH + 'my-lifestyle/chapter/diet-and-nutrition.png';
      case environment.products.bodyAndMind:
        return PATH + 'my-lifestyle/chapter/body-and-mind.png';
      case environment.products.sportAndRecreation:
        return PATH + 'my-lifestyle/chapter/sport-and-recreation.png';
      case environment.products.prsCancer:
        return PATH + 'my-health/chapter/cancer-risk.png';
      case environment.products.immuneSystem:
        return PATH + 'my-health/chapter/immune-system.png';
    }
  }
}
